import React, { useContext } from "react";
import { operativesRef } from "../firebase";
import { OperativesContext } from "../providers/OperativesProvider";
import { useHistory } from "react-router-dom";
import { useEditMode } from "../customHooks/useEditMode";
import { v4 as uuidv4 } from "uuid";
import Footer from "./Footer";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { AuthContext } from "../providers/AuthProvider";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import "../css/settingsLists.scss";
import { deleteDoc, doc, setDoc } from "firebase/firestore";
// import NoTimesheets from "./NoTimesheets";

const Operatives = () => {
  const { user } = useContext(AuthContext);
  const operatives = useContext(OperativesContext);
  const history = useHistory();

  const { inEditMode, toggleEditMode, isMarked, markItem, markedItems } =
    useEditMode();

  function editOperative(operative) {
    let operativeId = operative.uid;
    if (inEditMode) {
      markItem(operative);
    } else {
      let url = `/settings/operatives/${operativeId}`;
      history.push(url, { operative: operative });
    }
  }

  async function removeOperatives() {
    markedItems.forEach((uid) => {
      deleteDoc(doc(operativesRef, uid)).catch((err) => {
        console.error("Error deleting operatives", err);
      });
    });

    toggleEditMode();
  }

  async function addOperative() {
    let operativeId = uuidv4();

    let blankOperative = {
      uid: operativeId,
      createdBy: user.uid,
    };

    try {
      let url = `/settings/operatives/${operativeId}`;
      history.push(url, {
        rate: blankOperative,
        type: "operatives",
      });

      await setDoc(doc(operativesRef, operativeId), blankOperative);
    } catch (err) {
      console.error("Error adding operative:", err);
    }
  }

  let showBin = inEditMode && markedItems.length > 0;

  return (
    <div className="operativesPage">
      <Footer back={true} title="Operatives" backTo={"/"}>
        <button
          title="Edit"
          onClick={() => toggleEditMode(document.body)}
          className="adder"
        >
          <EditIcon style={{ fontSize: 25 }} />
        </button>
        {showBin ? (
          <button
            title="Delete Permanently"
            onClick={removeOperatives}
            className="adder"
          >
            <DeleteOutlinedIcon style={{ fontSize: 30 }} />
          </button>
        ) : (
          <button
            title="Add Operative"
            onClick={addOperative}
            className="adder"
          >
            <AddIcon style={{ fontSize: 30 }} />
          </button>
        )}
      </Footer>
      {/* <Footer title={"Operatives"} back={true}>
        <button onClick={toggleEditMode} className="adder">
          ~
        </button>

        <button onClick={addOperative} className="adder">
          @
        </button>
      </Footer> */}
      {/* <button className="addOperative" onClick={addOperative}>
        Add Operative
      </button>
      <button onClick={toggleEditMode}>
        edit mode <span>{String(inEditMode)}</span>
      </button> */}

      {/* {operatives.length === 0 && <NoTimesheets />} */}

      <div className="settingsList">
        {operatives.map((operative) => {
          let marked = isMarked(operative.uid);
          // console.log("op, ", operative);
          return (
            <button
              className="settingsCard"
              // style={marked ? markedItem : unmarkedItem}
              onClick={() => editOperative(operative)}
              key={operative.uid}
            >
              <div className="cardHeader">
                <span>{operative.name}</span>
                <span></span>
                <span>{operative.initials}</span>
              </div>
              <div className="cardBody">{operative.title}</div>
              <div className="cardFooter"></div>
              {marked && <div className="markedPrimary" />}
            </button>
          );

          // return (
          //   <p onClick={() => editOperative(operative)} key={operative.uid}>
          //     {operative.title} : {operative.name}
          //   </p>
          // );
        })}
      </div>
    </div>
  );
};

export default Operatives;
